import { FC } from 'react'
import { Avatar } from 'antd'
import PerIcon from '../Icon'
import './index.less'

interface Props {
  src?: string
  size?: 'large' | 'small' | 'default' | 'xlarge' | 'xxxlarge'
  firstName?: string
  lastName?: string
  square?: boolean
  unknown?: boolean
}

export const PerAvatar: FC<Props> = ({ src, size = 'default', firstName, lastName, square, unknown }) => {
  const modifiers: string[] = []
  const base = 'per-avatar'
  const antBase = 'ant-avatar'

  if (size === 'xlarge') {
    modifiers.push(antBase + '-xlg')
  } else if (size === 'xxxlarge') {
    modifiers.push(antBase + '-xxxlg')
  }

  if (unknown) {
    modifiers.push(base + '--unknown')
    modifiers.push(antBase)
    if (size === 'small') {
      modifiers.push(antBase + '-sm')
    } else if (size === 'large') {
      modifiers.push(antBase + '-lg')
    }
    if (square) {
      modifiers.push(antBase + '-square')
    } else {
      modifiers.push(antBase + '-circle')
    }
  }

  const unknownIconSize = () => {
    if (size === 'small') {
      return 22
    } else if (size === 'large') {
      return 36
    } else if (size === 'xlarge') {
      return 70
    } else if (size === 'xxxlarge') {
      return 116
    } else {
      return 30
    }
  }

  return (
    <>
      {unknown ? (
        <div className={base + ' ' + modifiers.join(' ')}>
          <PerIcon name="user_fill" color="secondary" size={unknownIconSize()} />
        </div>
      ) : (
        <Avatar
          src={src}
          size={size as 'large' | 'small' | 'default' | number}
          alt=""
          shape={square ? 'square' : 'circle'}
          className={base + ' ' + modifiers.join(' ')}
        >
          {firstName && lastName && firstName.substring(0, 1) + lastName.substring(0, 1)}
        </Avatar>
      )}
    </>
  )
}
